import React from "react";
import "./mission.css";
import { Zoom } from "react-reveal";

const Mission = ({ props }) => {
  return (
    <Zoom cascade>
      <div className="mission" style={{ "--clr": props.color }}>
        <h1>{props.id}.</h1>
        <p>{props.text}</p>
      </div>
    </Zoom>
  );
};

export default Mission;
